'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_3717c142 = {"container":"Link_module_container__a0c4cfa2","color-blue":"Link_module_colorBlue__a0c4cfa2","color-gray":"Link_module_colorGray__a0c4cfa2","color-dark":"Link_module_colorDark__a0c4cfa2","strong":"Link_module_strong__a0c4cfa2"};
require("../../../assets/cjs/components/Typography/src/Link~u4hWfMOT.css");

exports.default = modules_3717c142;
//# sourceMappingURL=Link.module.less.js.map
